// extracted by mini-css-extract-plugin
export default {"wrapper":"Mz-z","viewport":"Nz-z","container":"Oz-z","slide":"Pz-z"};